var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_6020)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39_6020",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39_6020)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 5.75C8.5 5.10721 8.69061 4.47886 9.04772 3.9444C9.40484 3.40994 9.91242 2.99338 10.5063 2.74739C11.1001 2.50141 11.7536 2.43705 12.384 2.56245C13.0145 2.68785 13.5936 2.99738 14.0481 3.4519C14.5026 3.90642 14.8122 4.48552 14.9376 5.11596C15.063 5.74639 14.9986 6.39986 14.7526 6.99372C14.5066 7.58758 14.0901 8.09516 13.5556 8.45228C13.0211 8.80939 12.3928 9 11.75 9C10.888 9 10.0614 8.65759 9.4519 8.0481C8.84241 7.4386 8.5 6.61195 8.5 5.75ZM11.75 1C10.8105 1 9.89217 1.27858 9.11104 1.80052C8.32991 2.32246 7.72109 3.0643 7.36157 3.93225C7.00206 4.8002 6.90799 5.75527 7.09127 6.67668C7.27455 7.59809 7.72694 8.44446 8.39124 9.10876C9.05554 9.77306 9.90191 10.2255 10.8233 10.4087C11.7447 10.592 12.6998 10.4979 13.5677 10.1384C14.4357 9.77891 15.1775 9.17009 15.6995 8.38896C16.2214 7.60783 16.5 6.68946 16.5 5.75C16.5 4.49022 15.9996 3.28204 15.1088 2.39124C14.218 1.50044 13.0098 1 11.75 1ZM8.55 13C7.07805 13 5.66638 13.5847 4.62556 14.6256C3.58473 15.6664 3 17.078 3 18.55C3 19.5976 3.41616 20.6023 4.15693 21.3431C4.8977 22.0838 5.90239 22.5 6.95 22.5H16.55C17.5976 22.5 18.6023 22.0838 19.3431 21.3431C20.0838 20.6023 20.5 19.5976 20.5 18.55C20.5 17.8212 20.3564 17.0995 20.0775 16.4261C19.7986 15.7528 19.3898 15.1409 18.8744 14.6256C18.3591 14.1102 17.7472 13.7014 17.0739 13.4225C16.4005 13.1436 15.6788 13 14.95 13H8.55ZM4.5 18.55C4.5 17.4759 4.92669 16.4457 5.68622 15.6862C6.44574 14.9267 7.47587 14.5 8.55 14.5H14.95C16.0241 14.5 17.0543 14.9267 17.8138 15.6862C18.5733 16.4457 19 17.4759 19 18.55C19 19.1998 18.7419 19.8229 18.2824 20.2824C17.8229 20.7419 17.1998 21 16.55 21H6.95C6.30022 21 5.67705 20.7419 5.21759 20.2824C4.75812 19.8229 4.5 19.1998 4.5 18.55Z",
    fill: "#808080"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_6020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-Icon.c39921e6bd6431945d64e78edea80e14.svg";
export { ForwardRef as ReactComponent };